import styled from 'styled-components/macro';

import {useBaseCommunity, useStoreCommunity} from "../store/hooks";
import NavLink from "./nav_link";
import {themecolors} from "../utils/themecolors";

const Inner = styled.div``;
const Logo = styled.div``;

const Text = styled.div``;
const Title = styled.div``;
const Subtitle = styled.div``;

const Buttons = styled.div``;

const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CommunityInfo = styled(({className, community, desktop}) => {
    const storeCommunity = useStoreCommunity(community);
    const logoUrl = storeCommunity?.icon ? `https://img.scored.co/community/${storeCommunity.name.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage;
    const baseCommunity = useBaseCommunity();
    return (
        <div className={`${className} brand-community-header-details`}>
            <Inner>
                <Logo>
                    <a href={`/c/${storeCommunity.name}`}>
                        <img src={logoUrl} />
                    </a>
                </Logo>
                <Text>
                    <NavLink href={`/c/${storeCommunity.name}`} react_route>
                        <Title>
                            {storeCommunity.display_name}
                        </Title>
                        <Subtitle>
                            {baseCommunity === "TheDonald" ? "America First!" :
                                storeCommunity.name && `${storeCommunity.name}`}
                        </Subtitle>
                    </NavLink>
                </Text>
                <Buttons />
            </Inner>
        </div>
    );
})`
  background: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  margin-bottom: 8px;


  ${Text} {
    margin-left: 138px;
  }
  
  ${Title} {
    font-weight: 600;
    line-height: 25px;
    font-size: 21px;
  }
  
  ${Subtitle} {
    font-size: 15px;
    font-weight: 400;
    line-height: 19px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_low_impact_text};
  }
  
  ${Logo} {
    border-radius: 50%;
  }
  
  ${Logo} img {
    border: 6px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    border-radius: 50%;
    width: 96px;
    height: 96px;
    position: absolute;
    margin-top: -66px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  }
  
  ${Inner} {
    padding: 0 24px;
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    flex: 0 0 83px;
    display: flex;
    align-items: center;
    height: 72px;
  }
  
  ${Buttons} {
    margin-left: auto;
  }
  @media only screen and (min-width: 781px) {
    &.mobile {
      display: none;
    }
  }
  @media only screen and (max-width: 780px) {
    padding: 0 24px;
    & {
      margin-bottom: 0;
      border-bottom: ${({theme}) => theme.color.name === 'dark' ? 'none' : `1px solid ${themecolors.lighter_border}`};
    }
    
    & {
      display: none;
    }
  }
`;

export default CommunityInfo;
